import {pages} from '@/config';
function isInExclude(path){
    // 判断无需登录页(分享等场景)
	const excludePage=pages.exclude;
	return excludePage.reduce((accumulator, current) => {
		return path.includes(current)||accumulator
	},false);
}
export {isInExclude}